import React, { memo } from "react";
import { Global, css } from "@emotion/core";

import IconEOT from "./assets/icons/icomoon.eot";
import IconTTF from "./assets/icons/icomoon.ttf";
import IconWOFF from "./assets/icons/icomoon.woff";

export const ICON_VARIABLES = {
    "icon-bag": "\\e901",
    "icon-tick": "\\e902",
    "icon-heart": "\\e903",
    "icon-minus": "\\e904",
    "icon-plus": "\\e905",
    "icon-magnify": "\\e906",
    "icon-cross": "\\e907",
    "icon-hamburger": "\\e908",
    "icon-tag": "\\e909",
    "icon-arrow": "\\e910",
    "icon-user": "\\e911",
    "icon-filter": "\\e912",
    "icon-sortby": "\\e913",
    "icon-elipses-v": "\\e914",
    "icon-success": "\\e915",
    "icon-move-to-wishlist": "\\e916",
    "icon-error": "\\e917",
    "icon-list": "\\e918",
    "icon-android-share": "\\e919",
    "icon-share": "\\e920",
    "icon-log-in": "\\e921",
    "icon-log-out": "\\e922",
    "icon-notification": "\\e923",
    "icon-orders": "\\e924",
    "icon-down": "\\e925",
    "icon-broken-link": "\\e926",
    "icon-back": "\\e927",
    "icon-danger": "\\e928",
    "icon-view-similar": "\\e929",
    "icon-info": "\\e930",
    "icon-genuine-products": "\\e931",
    "icon-free-shipping": "\\e932",
    "icon-secure-payment": "\\e933",
    "icon-trending": "\\e934",
    "icon-cancel": "\\e935",
    "icon-clock": "\\e936",
    "icon-bin": "\\e937",
    "down-fill": "\\e938",
    "icon-discount-fill": "\\e939",
    "icon-percentage": "\\e940",
    "icon-cod": "\\e941",
    "icon-delivery": "\\e944",
    "icon-freedelivery": "\\e943",
    "icon-internationally": "\\e942",
};

const iconStyles = css`
    @font-face {
        font-family: "icomoon";
        src: url("${IconWOFF}?4wir88") format("woff"),
            url("${IconTTF}?4wir88") format("truetype"),
            url("${IconEOT}?4wir88#iefix") format("embedded-opentype");
        font-weight: normal;
        font-style: normal;
    }

    [class^="icon-"], [class*=" icon-"] {
        /* use !important to prevent issues with browser extensions that change fonts */
        font-family: 'icomoon' !important;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;

        /* Better Font Rendering =========== */
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .icon-bag:before {
        content: "${ICON_VARIABLES["icon-bag"]}";
    }
    .icon-tick:before {
        content: "${ICON_VARIABLES["icon-tick"]}";
    }
    .icon-heart:before {
        content: "${ICON_VARIABLES["icon-heart"]}";
    }
    .icon-minus:before {
        content: "${ICON_VARIABLES["icon-minus"]}";
    }
    .icon-plus:before {
        content: "${ICON_VARIABLES["icon-plus"]}";
    }
    .icon-magnify:before {
        content: "${ICON_VARIABLES["icon-magnify"]}";
    }
    .icon-cross:before {
        content: "${ICON_VARIABLES["icon-cross"]}";
    }
    .icon-hamburger:before {
        content: "${ICON_VARIABLES["icon-hamburger"]}";
    }
    .icon-tag:before {
        content: "${ICON_VARIABLES["icon-tag"]}";
    }
    .icon-arrow:before {
        content: "${ICON_VARIABLES["icon-arrow"]}";
    }
    .icon-user:before {
        content: "${ICON_VARIABLES["icon-user"]}";
    }
    .icon-filter:before {
        content: "${ICON_VARIABLES["icon-filter"]}";
    }
    .icon-sortby:before {
        content: "${ICON_VARIABLES["icon-sortby"]}";
    }
    .icon-elipses-v:before {
        content: "${ICON_VARIABLES["icon-elipses-v"]}";
    }
    .icon-success:before {
        content: "${ICON_VARIABLES["icon-success"]}";
    }
    .icon-move-to-wishlist:before {
        content: "${ICON_VARIABLES["icon-move-to-wishlist"]}";
    }
    .icon-error:before {
        content: "${ICON_VARIABLES["icon-error"]}";
        color: #f00;
    }
    .icon-list:before {
        content: "${ICON_VARIABLES["icon-list"]}";
    }
    .icon-android-share:before {
        content: "${ICON_VARIABLES["icon-android-share"]}";
    }
    .icon-share:before {
        content: "${ICON_VARIABLES["icon-share"]}";
    }
    .icon-log-in:before {
        content: "${ICON_VARIABLES["icon-log-in"]}";
    }
    .icon-log-out:before {
        content: "${ICON_VARIABLES["icon-log-out"]}";
    }
    .icon-notification:before {
        content: "${ICON_VARIABLES["icon-notification"]}";
    }
    .icon-orders:before {
        content: "${ICON_VARIABLES["icon-orders"]}";
    }
    .icon-down:before {
        content: "${ICON_VARIABLES["icon-down"]}";
    }
    .icon-broken-link:before {
        content: "${ICON_VARIABLES["icon-broken-link"]}";
    }
    .icon-back:before {
        content: "${ICON_VARIABLES["icon-back"]}";
    }
    .icon-danger:before {
        content: "${ICON_VARIABLES["icon-danger"]}";
    }
    .icon-view-similar:before {
        content: "${ICON_VARIABLES["icon-view-similar"]}";
    }
    .icon-info:before {
        content: "${ICON_VARIABLES["icon-info"]}";
    }
    .icon-up:before {
        content: "${ICON_VARIABLES["icon-down"]}";
        transform: rotate(180deg);
    }
    .icon-genuine-products:before {
        content: "${ICON_VARIABLES["icon-genuine-products"]}";
    }
    .icon-free-shipping:before {
        content: "${ICON_VARIABLES["icon-free-shipping"]}";
    }
    .icon-secure-payment:before {
        content: "${ICON_VARIABLES["icon-secure-payment"]}";
    }
    .icon-cancel:before {
        content: "${ICON_VARIABLES["icon-cancel"]}";
    }
    .icon-trending:before {
        content: "${ICON_VARIABLES["icon-trending"]}";
    }
    .icon-clock:before {
        content: "${ICON_VARIABLES["icon-clock"]}";
    }
    .icon-bin:before {
        content: "${ICON_VARIABLES["icon-bin"]}";
    }
    .icon-dropdown-down:before {
        content: "${ICON_VARIABLES["down-fill"]}";
       
    }
    .icon-dropdown-up:before {
        content: "${ICON_VARIABLES["down-fill"]}";
        display: inline-block;
        transform: rotate(180deg);
        position: relative;
        top: -1px;
    }
    .icon-discount-fill:before {
        content: "${ICON_VARIABLES["icon-discount-fill"]}";
    }
    .icon-percentage:before {
        content: "${ICON_VARIABLES["icon-percentage"]}";
    }
    .icon-cod:before {
        content: "${ICON_VARIABLES["icon-cod"]}";
    }
    .icon-delivery:before {
        content: "${ICON_VARIABLES["icon-delivery"]}";
    }
    .icon-freedelivery:before {
        content: "${ICON_VARIABLES["icon-freedelivery"]}";
    }
    .icon-internationally:before {
        content: "${ICON_VARIABLES["icon-internationally"]}";
    }
    .icon-error-fill:before {
        content: "${ICON_VARIABLES["icon-info"]}";
        transform: rotate(180deg);
        color: red;
    }   
`;

function Icons() {
    return <Global styles={iconStyles} />;
}

export default memo(Icons);
